var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tab',{attrs:{"id":"EFECTY","data-test":"EFECTY","title-link-class":"tab-nav-icon EFECTY"},on:{"click":function($event){return _vm.$emit('click')}},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":"credit-card"}}),_vm._v(" EFECTY ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }